
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.7001 19.7C18.0901 19.31 18.0901 18.68 17.7001 18.29L15.0001 15.59L13.5901 17L16.2901 19.7C16.6801 20.09 17.3201 20.09 17.7001 19.7ZM8.71006 8.00002H11.0001V13.59L6.29006 18.29C5.90006 18.68 5.90006 19.31 6.29006 19.7C6.68006 20.09 7.31006 20.09 7.70006 19.7L13.0001 14.4V8.00002H15.2901C15.7401 8.00002 15.9601 7.46002 15.6401 7.15002L12.3501 3.86002C12.1501 3.66002 11.8401 3.66002 11.6401 3.86002L8.35006 7.15002C8.04006 7.46002 8.26006 8.00002 8.71006 8.00002Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-call-merge`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCallMerge

    ```js
    <b-new-b-icon-call-merge />
    ```
</docs>


